import { serverApi } from 'src/utils/request'
import Paths from 'src/utils/paths'
import { IActiveTripResponseV2, IIntegrationProductResponse } from 'src/types'
import { IPortalProduct, IPortalTripFilters, IService, IZone } from 'src/types/rider-portal-state'
import { IAvailableProductsPayload, ICreateTripBooking } from 'src/types/rider-portal'

class RiderPortal {
  public async createTripBooking(payload: ICreateTripBooking): Promise<IActiveTripResponseV2> {
    const endpoint = payload.scheduledPickupTime ? Paths.trips.scheduled : Paths.tripsBaseUrl
    const result = await serverApi.post<any>(endpoint, payload)
    return result.data
  }

  public async getAvailableProducts(
    payload: IAvailableProductsPayload,
    riderId: string
  ): Promise<IIntegrationProductResponse[]> {
    const endpoint = Paths.rider.availableProductsv2.replace(':riderId', riderId)
    const result = await serverApi.post<any>(endpoint, payload)
    return result.data
  }

  public async getServicesByCurrenLocation(
    currentLocations: google.maps.LatLngLiteral,
    orgId: string,
    type: string
  ): Promise<IService[]> {
    const endpoint = `${Paths.riderPortal.getServicesByCurrenLocation}?types=${type}&orgId=${orgId}`
    const payload = {
      locations: [currentLocations]
    }
    const result = await serverApi.post<any>(endpoint, payload)
    return result.data.services
  }

  public async getServiceDesignatedZones(serviceId: string): Promise<IZone[]> {
    const endpoint = `${Paths.serviceDesignatedZoneBaseUrl}/${serviceId}`
    const result = await serverApi.get<any>(endpoint)
    return result.data
  }

  public async getServiceZones(organizationId: string, serviceId: string): Promise<IZone[]> {
    const endpoint = `${Paths.zoneServiceBaseUrl}?organizationId=${organizationId}&serviceId=${serviceId}`
    const result = await serverApi.get<any>(endpoint)
    return result.data
  }
}

const riderPortalService = new RiderPortal()

export { riderPortalService }



// WEBPACK FOOTER //
// ./src/services/rider-portal/index.ts